"use client";

interface InitialsAvatarProps {
  label: string;
  className?: string;
  size?: "sm" | "md";
}

/**
 * Circular initials avatar used on guest cards (and reusable for staff tiles).
 * Takes the first letter of up to two whitespace-separated words.
 */
export default function InitialsAvatar({
  label,
  className = "",
  size = "md",
}: InitialsAvatarProps) {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  const initials =
    parts.length === 0
      ? "?"
      : parts
          .slice(0, 2)
          .map((p) => p[0]?.toUpperCase() ?? "")
          .join("");

  const sizeClass =
    size === "sm"
      ? "w-10 h-10 text-sm"
      : "w-12 h-12 sm:w-14 sm:h-14 text-sm sm:text-lg";

  return (
    <div
      className={`${sizeClass} bg-green-50 rounded-full flex items-center justify-center flex-shrink-0 ${className}`}
      aria-hidden
    >
      <span className="font-semibold text-green-600">{initials}</span>
    </div>
  );
}
